module.exports = __webpack_public_path__ + "media/images/illusion-3fb2d443921d06e63e3e6871fe0c1ebf.jpg";